/** Design tokens Codex — source de vérité pour la charte graphique. */
export const tokens = {
  colors: {
    primary: '#12047D',
    primaryLight: '#4c31ac',
    primaryDark: '#00004f',
    secondary: '#7fe1dd',
    secondaryLight: '#adffff',
    secondaryDark: '#43aea9',
    warning: '#E7813D',
    backgroundLight: '#F8F8F8',
    backgroundDark: '#161d31',
    paperDark: '#283046',
    selection: '#79E0DB',
    impersonation: '#7fe1dd',
  },
  layout: {
    drawerWidth: 280,
    appBarMargin: 10,
    contentMaxWidth: '100%',
    contentPaddingX: { xs: 1.5, sm: 2 },
  },
  shape: {
    borderRadius: 7,
    borderRadiusSm: 4,
  },
  shadow: {
    card: '0 4px 24px 0 rgba(34,41,47,.1)',
    subtle: '0 2px 12px 0 rgba(34,41,47,.06)',
  },
  spacing: {
    navItemInset: 12,
    sectionLabel: 2,
  },
} as const;

export type AppTokens = typeof tokens;
